/**
 * @packageDocumentation
 * @module api.functional.admin.internal_companies
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { InternalCompanyLookupQueryDto } from "../../../structures/InternalCompanyLookupQueryDto";
import type { ServiceResponseInternalCompanynull } from "../../../structures/ServiceResponseInternalCompanynull";

/**
 * @controller InternalCompanyController.getInternalCompanies
 * @path GET /admin/internal-companies
 * @accessor api.functional.admin.internal_companies.getInternalCompanies
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getInternalCompanies(
  connection: IConnection,
  query: getInternalCompanies.Query,
): Promise<getInternalCompanies.Output> {
  return PlainFetcher.fetch(connection, {
    ...getInternalCompanies.METADATA,
    template: getInternalCompanies.METADATA.path,
    path: getInternalCompanies.path(query),
  });
}
export namespace getInternalCompanies {
  export type Query = InternalCompanyLookupQueryDto;
  export type Output = ServiceResponseInternalCompanynull;

  export const METADATA = {
    method: "GET",
    path: "/admin/internal-companies",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (query: Query) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/admin/internal-companies";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}

/**
 * @controller InternalCompanyController.getInternalCompanyById
 * @path GET /admin/internal-companies/:id
 * @accessor api.functional.admin.internal_companies.getInternalCompanyById
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getInternalCompanyById(
  connection: IConnection,
  id: string,
): Promise<getInternalCompanyById.Output> {
  return PlainFetcher.fetch(connection, {
    ...getInternalCompanyById.METADATA,
    template: getInternalCompanyById.METADATA.path,
    path: getInternalCompanyById.path(id),
  });
}
export namespace getInternalCompanyById {
  export type Output = ServiceResponseInternalCompanynull.o1;

  export const METADATA = {
    method: "GET",
    path: "/admin/internal-companies/:id",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (id: string) =>
    `/admin/internal-companies/${encodeURIComponent(id?.toString() ?? "null")}`;
}
